module.exports = __webpack_public_path__ + "img/sw-orientation.0fe01a97.png";